import { useState, useEffect } from 'react';

// Our hook
export default function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            if (value && value.length !== 0) {
                clearTimeout(handler);
            }
        };
    }, [value]);

    return debouncedValue;
}
